import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import NuvoApp from "./component/NuvoApp";
import DeliveriesScreen from "./component/DeliveriesScreen";
import FreightApp from "./component/FreightApp";
import FreightScreen from "./component/FreightScreen";
import LoadingScreen from "./component/LoadingScreen";
import LoadingApp from "./component/LoadingApp";
import Login from "./component/Login";
import MasterScreen from "./component/MasterScreen";
import MasterApp from "./component/MasterApp";
import ContractScreen from "./component/ContractScreen";
import ContractApp from "./component/ContractApp";
import PageNotFound from "./PageNotFound";
import AuthenticationToken from './component/AuthenticationToken';
import MasterStandardApp from "./component/MasterStandardApp";
import TransportApp from "./component/TransportApp";
import TransportScreen from "./component/TransportScreen";
import TransportAllRateApp from "./component/TransportAllRateApp";
import TransportAllRateScreen from "./component/TransportAllRateScreen";
import UploaderScreen from "./component/UploaderScreen"
import TransactionalScreen from "./component/TransactionalScreen";
import TransactionalApp from "./component/TransactionalApp";
import RootDirec from "./App";
import {
  ApolloProvider,
  ApolloLink,
  ApolloClient,
  InMemoryCache,
  HttpLink,
} from "@apollo/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { PAGES } from "./constants/Pages";
import PrivateRoute from "./component/PrivateRoute";
const httpLink = new HttpLink({ uri: process.env.REACT_APP_URL });
const authLink = new ApolloLink((operation, forward) => {
  // Retrieve the authorization token from local storage.
  let TOKEN = localStorage.getItem("TOKEN");

  // Use the setContext method to set the HTTP headers.
  operation.setContext({
    headers: {
      authorization: TOKEN,
    },
  });

  // Call the next link in the middleware chain.
  return forward(operation);
});
const client = new ApolloClient({
  link: authLink.concat(httpLink), // Chain it with the HttpLink
  cache: new InMemoryCache(),
  connectToDevTools: true, // Enable Apollo DevTools
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ApolloProvider client={client}>
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route exact path="/appDir" element={<RootDirec />} />
          <Route 
            exact path={PAGES.UPLOADERSCREEN} element={
              <PrivateRoute>
                <UploaderScreen />
              </PrivateRoute>  
            } />
          <Route 
            path={`${PAGES.NUVOAPP}/:id`} element={
              <PrivateRoute>
                <NuvoApp />
              </PrivateRoute>
            } />
          <Route 
            exact path={PAGES.FREIGHTSCREEN} element={
              <PrivateRoute>
                <FreightScreen />
              </PrivateRoute>  
            } />
          <Route 
            path={`${PAGES.FREIGHTAPP}/:id`} element={
              <PrivateRoute>
                <FreightApp />
              </PrivateRoute>
            } />
          <Route 
            exact path={PAGES.UPLOADERSCREEN} element={
              <PrivateRoute>
                <UploaderScreen />
              </PrivateRoute>
            } />
          <Route 
            path={`${PAGES.LOADINGAPP}/:id`} element={
              <PrivateRoute>
                <LoadingApp />
              </PrivateRoute>  
            } />
          <Route 
            exact path={PAGES.MASTERSCREEN} element={
              <PrivateRoute>
                <MasterScreen />
              </PrivateRoute>  
            } />
          <Route 
            path={PAGES.MASTERAPP} element={
              <PrivateRoute>
                <MasterApp />
              </PrivateRoute>  
            } />
          <Route 

            path={`${PAGES.MASTERSTANDARDAPP}/:id`} element={
              <PrivateRoute>
                <MasterStandardApp />
              </PrivateRoute>  
            } />
          <Route 
            exact path={PAGES.CONTRACTSCREEN} element={
              <PrivateRoute>
                <ContractScreen />
              </PrivateRoute>  
            } />
          <Route 
            path={`${PAGES.CONTRACTAPP}/:id`} element={
              <PrivateRoute>
                <ContractApp />
              </PrivateRoute>  
            } />  
          <Route 
            exact path={PAGES.TRANSPORTSCREEN} element={
              <PrivateRoute>
                <TransportScreen />
              </PrivateRoute>  
            } />
          <Route 
            path={`${PAGES.TRANSPORTAPP}`} element={
              <PrivateRoute>
                <TransportApp />
              </PrivateRoute>
            } />
          <Route 
            exact path={PAGES.TRANSPORTALLRATESCREEN} element={
              <PrivateRoute>
                <TransportAllRateScreen />
              </PrivateRoute>  
            } />
          <Route 
            path={`${PAGES.TRANSPORTALLRATEAPP}/:id`} element={
              <PrivateRoute>
                <TransportAllRateApp />
              </PrivateRoute>
            } />  
          <Route 
            exact path={PAGES.UPLOADERSCREEN} element={
              <PrivateRoute>
                <UploaderScreen />
              </PrivateRoute>  
            } />
          <Route 
            exact path={PAGES.TRANSACTIONALSCREEN} element={
              <PrivateRoute>
                <TransactionalScreen />
              </PrivateRoute>  
            } />
          <Route 
            path={`${PAGES.TRANSACTIONALAPP}`} element={
              <PrivateRoute>
                <TransactionalApp />
              </PrivateRoute>
            } />    
          <Route exact path="/" element={<Login />} />
          <Route exact path="/404" element={<PageNotFound />} />
          <Route exact path={PAGES.AUTHENTICATION_TOKEN} element={<AuthenticationToken />} />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  </ApolloProvider>
);
reportWebVitals();